module.exports = __webpack_public_path__ + "static/media/bill_edit_icon.05d7bd53.svg";